// capital letter for component

import React, { useState, useEffect } from "react";
import "./Row.css";
import Youtube from "react-youtube";
// export default instance that's why we can rename to axios
import axios from "./axios";
import movieTrailer from "movie-trailer";

// base URL to make requests to the movie database
const base_url = "http://image.tmdb.org/t/p/original/";

function Row({ title, fetchURL, large }) {
  // State is a short term memory. it is a variable in react.
  // It is a way to write a variable in react. Here we are using useState hook.
  const [movies, setMovies] = useState([]);
  const [trailerUrl, setTrailerUrl] = useState("");

  // A snippet of code which runs on specific condition/variable
  // useEffect is a hook in react. It is a piece of code which runs based on a specific condition.
  useEffect(() => {
    // Asynchronous function to fetch data from API because it takes time to fetch data.
    async function fetchData() {
      // await is used to wait for the response from the API.
      // http://api.themoviedb.org/3/discover/tv?api_key=f785e525387b280b1d86759d7ac60a1c&with_networks=213
      const request = await axios.get(fetchURL);
      // console.log("Movies: " + request);
      setMovies(shuffleArray(request.data.results));
      return request;
    }
    fetchData();

    // if [], run once when the row loads, and don't run again
    // if [fetchURL], run once when the row loads, and run again when movies changes
    // now setMovies is dependent on fetchURL so we have to load again and again
  }, [fetchURL]);

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const handleClick = (movie) => {
    if (trailerUrl) {
      movieTrailer(movie?.name || movie?.title || movie?.original_name || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          if (urlParams.get("v") == trailerUrl) setTrailerUrl("");
          else setTrailerUrl(urlParams.get("v"));
        })
        .catch((error) => alert(`${movie.name} N/A`));
    } else {
      movieTrailer(movie?.name || movie?.title || movie?.original_name || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          setTrailerUrl(urlParams.get("v"));
        })
        .catch((error) => alert(`${movie.name} N/A`));
    }
    // movieTrailer(movie?.name || movie?.title || movie?.original_name || "")
    //   .then((url) => {
    //     // https://www.youtube.com/watch?v=XtMThy8QKqU
    //     const urlParams = new URLSearchParams(new URL(url).search);
    //     if (urlParams.get("v") === trailerUrl) {
    //       setTrailerUrl(urlParams.get("v"));
    //     } else {
    //       setTrailerUrl("");
    //     }
    //   })
    //   .catch((error) => {
    //     alert(`${movie.name} N/A`);
    //   });
  };

  function truncate(str, n) {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  }

  return (
    <div className="row">
      {/* title */}
      <h2>{title}</h2>

      {/* container -> posters */}
      <div className="Posters">
        {/* several row_posters */}

        {movies.map((movie) => (
          <div className="row__poster__content">
            <img
              key={movie.id}
              onClick={() => handleClick(movie)}
              className={`row_poster ${large && "row_bigposter"}`}
              src={`${base_url}${
                large
                  ? movie.poster_path
                  : movie.backdrop_path || movie.poster_path
              }`}
              alt={movie.name}
            />
            {!large && (
              <h2 className="row__poster__title">
                {truncate(
                  movie?.name || movie?.title || movie?.original_name,
                  27
                )}
              </h2>
            )}
          </div>
        ))}
      </div>
      {/* if trailerUrl is not empty then show the video */}
      {trailerUrl && <Youtube videoId={trailerUrl} opts={opts} />}
    </div>
  );
}

function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}

export default Row;
